export default {
    state: {
        gestiones: [],
        loading: false,
    },
    getters: {
        gestiones: (state) => state.gestiones,
        loading: state => state.loading,
    },
    mutations: {
        SET_GESTIONES: (state, payload) => state.gestiones = payload,
        setLoading: (state, payload) => state.loading = payload,
    },
    actions: {
        fetch({
            commit
        }, payload) {
            this.dispatch('index', payload)
                .then((response) => {
                    commit('SET_GESTIONES', response.datos)
                })
        },
        cargarGestion({
            commit,
            dispatch
        }, payload) {
            return new Promise((res, rej) => {
                this.getters.api.post('/utilidades/cargue-masivo-gestion', payload)
                    .then(response => {
                        res(response)
                    }).catch(error =>
                        rej(error)
                    )
            })
        }
    }
}